import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintEntityId} from "../utils/uid.utils";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {AddImagePackCommand} from "./addImagePack.command";

export class AddResourceCommand extends CommandBase {
    private name: string;
    // Id minted for the created resource; read after executeCommand to focus it.
    newId = '';
    constructor(name: string = 'New Resource') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        data.resources ??= [];
        const id = mintEntityId('resource', this.name, data.resources.map(r => r.id));
        this.newId = id;
        data.resources.push({
            id: id,
            active: true,
            visionModifier: 0,
            startCount: 0,
            rarity: 100,
            attributes: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);
        return true;
    }
}